export const MusterChecklistModalTypes = Object.freeze({
    ADD: "ADD",
    EDIT: "EDIT",
});
